module.exports = __webpack_public_path__ + "static/media/icon_chevron_right_blue.9b9ba630.svg";